import { render, staticRenderFns } from "./stepSpeaker.vue?vue&type=template&id=3b7ff3fe&scoped=true&"
import script from "./stepSpeaker.vue?vue&type=script&lang=ts&"
export * from "./stepSpeaker.vue?vue&type=script&lang=ts&"
import style0 from "./stepSpeaker.vue?vue&type=style&index=0&id=3b7ff3fe&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b7ff3fe",
  null
  
)

export default component.exports